import React from "react";
import { useStore } from "../store";
import Section from "../components/section/section";
import HexagonButton from "../components/hexagon-button/hexagon-button";
import Hexagon1 from "../components/hexagon-1";
import Hexagon2 from "../components/hexagon-2";
import Hexagon3 from "../components/hexagon-3";

export default function EndFrame41() {
  const { section, setSection, showEndFrame } = useStore();
  const watchedSections = React.useMemo(() => {
    return (
      JSON.parse(window.localStorage.getItem(`kasperskey.watchedSections`)) ??
      []
    );
  }, [section]);

  if (section !== 4.1 || !showEndFrame) return null;

  return (
    <Section name="4-1">
      <HexagonButton
        onClick={() => setSection(4.1)}
        disabled={watchedSections.includes(4.1)}
      >
        <div>Accept</div>
        <Hexagon1 />
      </HexagonButton>
      <HexagonButton
        onClick={() => setSection(4.2)}
        disabled={watchedSections.includes(4.2)}
      >
        <div>Reject</div>
        <Hexagon2 />
      </HexagonButton>
      <HexagonButton
        onClick={() => setSection(4.3)}
        disabled={watchedSections.includes(4.3)}
      >
        <div>Smash!</div>
        <Hexagon3 />
      </HexagonButton>
    </Section>
  );
}
